module.exports = __webpack_public_path__ + "static/prm-f149dce388d8f80473dd9ac0b3586e73.jpg";